
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(108|213)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
